import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { Children } from "react";
import Title from "../../../../../base/text/title/index.js";
import { Container } from "../../../../../../styles/common/mixins/container.styled.js";
import MasonryCard from "./components/masonryCard/views/desktop/index.js";
import ViewMoreMasonryCard from "./components/viewMoreMasonryCard.js";
import { defaultWidth, skins } from "./constants.js";
import * as S from "./styled.js";
/* MasonryCarousel with simple card */ const renderSimpleCard = ({ card , height  })=>{
    const { image: ImageSimpleCard  } = card;
    const imageCard = {
        ...ImageSimpleCard,
        width: defaultWidth,
        resize: {
            width: Number(defaultWidth),
            height: Number(height)
        }
    };
    return /*#__PURE__*/ _jsx(S.CardSimpleDsk, {
        ...card,
        image: imageCard,
        height: height
    });
};
/* Build Splide Items.
	Creates an array of arrays.
	The first array refers to the number of items that the splite will have.
	Within each position we will find two items(top and bottom cards with diff heights)
*/ const buildItems = (items)=>items?.reduce((rows, key, index)=>{
        if (index % 2 == 0) {
            rows.push([
                key
            ]);
            return rows;
        }
        rows[rows.length - 1].push(key);
        return rows;
    }, []) ?? [];
export const Masonry = ({ props  })=>{
    const { title , subtitle , items =[] , skin_masonry ='3' , view_more =undefined , cardTitleVariant ='primary' , backgroundVariant ='primary' , isSimpleCard =false , isRegular =false  } = props ?? {};
    const newItems = buildItems(items);
    const skin = skins[+skin_masonry];
    const heights = skin.height;
    let count = -1;
    return /*#__PURE__*/ _jsx(S.MasonryBox, {
        className: classNames([
            `bg_${backgroundVariant}`
        ]),
        "data-testid": "Masonry",
        children: /*#__PURE__*/ _jsxs(Container, {
            children: [
                /*#__PURE__*/ _jsx(Title, {
                    title: title?.content,
                    subTitle: subtitle?.content
                }),
                /*#__PURE__*/ _jsx(S.MasonrySlider, {
                    perPage: skin.perPage,
                    perMove: skin.perMove,
                    gap: isRegular ? 2 : 16,
                    breakpoints: skin.breakpoints,
                    pagination: false,
                    speed: 1000,
                    children: Children.toArray(newItems.map((item, index)=>/*#__PURE__*/ _jsxs(S.MasonryWrapperCards, {
                            children: [
                                Children.toArray(item.map((card)=>{
                                    if (count >= heights.length - 1) count = -1;
                                    count++;
                                    const masonryCardPros = {
                                        card,
                                        height: isRegular ? 320 : heights[count],
                                        cardTitleVariant,
                                        isRegular
                                    };
                                    return /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            !isSimpleCard && /*#__PURE__*/ _jsx(S.MasonryCard, {
                                                $isRegular: isRegular,
                                                ...card.link,
                                                children: /*#__PURE__*/ _jsx(MasonryCard, {
                                                    ...masonryCardPros
                                                })
                                            }),
                                            isSimpleCard && renderSimpleCard({
                                                card,
                                                height: `${heights[count]}`
                                            })
                                        ]
                                    });
                                })),
                                view_more && newItems.length === index + 1 && /*#__PURE__*/ _jsx(ViewMoreMasonryCard, {
                                    view_more,
                                    count,
                                    heights
                                })
                            ]
                        })))
                })
            ]
        })
    });
};
export default Masonry;

//# sourceMappingURL=index.js.map